import React from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';

import { Media } from '../../store/modules/media-viewer/types';

import MediaPreviewStyles from './styles';

type Props = {
  media: Media;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const MediaImage = ({
  media, swipeable, slideDirection, isChangePreviewMedia,
}: Props) => {
  const classes = MediaPreviewStyles();

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div {...swipeable} className={classes.wrapper}>
        <img src={media.url} alt="" className={classes.image} />
      </div>
    </Slide>
  );
};

export default MediaImage;
